import { IImage } from './image.model';
import { IMediaBrand } from './media-brand.model';

export interface IProduct {
	name: string;
	description: string;
	shortDescription: string;
	price: number;
	taxRate: number;
	productKind: ProductKind;
	image: IImage;
	additionalImages: IImage[];
	logo: IImage;
	link: string;
	mediaBrand: IMediaBrand;
}

export enum ProductKind {
	MediaProduct = 'MediaProduct',
	AccessoryProduct = 'AccessoryProduct',
}

export enum OccasionType {
	Birthday = 'Geburtstag',
	Silver = 'Silberhochzeit',
	Gold = 'Goldene Hochzeit',
	Diamond = 'Diamantene Hochzeit',
	Retirement = 'Ruhestand',
	Christmas = 'Weihnachten',
	Custom = '(Eigener Anlass)',
}

export enum AddressForm {
	Personal = 'Dein',
	Formally = 'Ihr',
}
